import { currencyFormat } from "@/validator/globalvalidator";

export default function quantityFilter(value: number): string {
    return currencyFormat(value) || "0.00";
}